import { render, staticRenderFns } from "./DataHome.vue?vue&type=template&id=fc9a52e6&scoped=true"
import script from "./DataHome.vue?vue&type=script&lang=js"
export * from "./DataHome.vue?vue&type=script&lang=js"
import style0 from "./DataHome.vue?vue&type=style&index=0&id=fc9a52e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9a52e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc9a52e6')) {
      api.createRecord('fc9a52e6', component.options)
    } else {
      api.reload('fc9a52e6', component.options)
    }
    module.hot.accept("./DataHome.vue?vue&type=template&id=fc9a52e6&scoped=true", function () {
      api.rerender('fc9a52e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/DataHome.vue"
export default component.exports